export default __webpack_public_path__ + "static/media/404.c4fcb63b.svg";